import { ButtonTriggerEvent } from '../../../../common/components';

export class ShareTripModalActions {
    confirm: (event: ButtonTriggerEvent, social: string) => void;
    cancel?: () => void;
}

export class ShareTripModalData {
    wholeTripId: string;
    singleTripId: string;
    hubName: string;
    type: string;
    title: string;
    isWholeTrip: boolean;
    singleTripIndex: number;
    constructor(wholeTripId, hubName, type, isWholeTrip, singleTripId, title, singleTripIndex) {
        this.wholeTripId = wholeTripId;
        this.singleTripId = singleTripId;
        this.hubName = hubName;
        this.type = type;
        this.isWholeTrip = isWholeTrip;
        this.title = title;
        this.singleTripIndex = singleTripIndex;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/share.trip.modal/share.trip.modal.provider.ts